import { gql } from '@apollo/client'

export const SABRE_GET_PACKAGING_UNIT_OPTIONS = gql`
  query GetPackagingUnitOptions($input: PackagingOptionQueryInput) {
    packagingUnits(input: $input) {
      count
      hasMore
      results
    }
  }
`
